export const API_RECIPIENT = {
  class: "this.fetchClassOpts(responseData)",
  term: "this.fetchTermOpts(responseData)",
  grade: "this.fetchGradeOpts(responseData)",
  program: "this.fetchProgramOpts(responseData)",
  student: "this.fetchStudentOpts(responseData)",
  parent: "this.fetchFamilyOpts(responseData)",
  teacher: "this.fetchTeacherOpts(responseData)"
};
export const LIST_RECIPIENT = {
  class: "classList",
  term: "termList",
  grade: "gradeList",
  program: "programList",
  student: "studentList",
  parent: "parentList",
  teacher: "teacherList"
};
export const API_DEBOUNCE = {
  class:
    "this.debounceSearchKey(event, {'name__~':event,limit: 20},      `${path.classes}`)",
  term:
    "this.debounceSearchKey(event,{'name__~':event,limit: 20,order_by:'created_at DESC'},`${path.terms}`)",
  grade:
    "this.debounceSearchKey(event,{'name__~':event,limit: 20},`${path.grades}`)",
  program:
    "this.debounceSearchKey(event,{'name__~':event,limit: 20},`${path.programs}`)",
  student:
    "this.debounceSearchKey(event,{'search_key':event,fields:['full_name','student_code'],limit: 20},`${path.students}/filter`)",
  parent:
    "this.debounceSearchKey(event,{'search_key':event,fields:['full_name','username'],limit: 20},`${path.families}/filter`)",
  teacher:
    "this.debounceSearchKey(event,{'search_key':event,fields:['full_name','staff_code'],limit: 20},`${path.staffs}/filter?role_names=Teacher`)"
};

export const STUDENT_LIST = [
  {
    id: "all",
    name: "common.all"
  },
  {
    id: "class",
    name: "common.class"
  },
  {
    id: "term",
    name: "common.term"
  },
  {
    id: "grade",
    name: "common.grade"
  },
  {
    id: "program",
    name: "common.program"
  },
  {
    id: "student",
    name: "communication.student_name_student_id"
  }
];
export const FAMILY_LIST = [
  {
    id: "all",
    name: "survey.family_of_student"
  },
  {
    id: "class",
    name: "survey.family_belong_class"
  },
  {
    id: "term",
    name: "survey.family_belong_term"
  },
  {
    id: "grade",
    name: "survey.family_belong_grade"
  },
  {
    id: "program",
    name: "survey.family_belong_program"
  },
  {
    id: "student",
    name: "survey.family_belong_student_name_id"
  },
  {
    id: "parent",
    name: "survey.parent_name_username"
  }
];
export const TEACHER_LIST = [
  {
    id: "all",
    name: "common.all"
  },
  {
    id: "class",
    name: "survey.teacher_of_class"
  },
  {
    id: "term",
    name: "survey.teacher_of_class_belong_term"
  },
  {
    id: "teacher",
    name: "survey.teacher_name_staff_id"
  }
];
